export default "__VITE_ASSET__BCULzDh1__"